import { Select } from './elements';
import Filter from './Filter';

const FilterCategoryPrice = () => {
  return (
    <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-2">
      <div className="md:w-8/12">
        <Filter />
      </div>
      <div className="grid grid-cols-2 gap-2 md:w-4/12">
        <Select placeholder="Category" />
        <Select placeholder="Price" />
      </div>
    </div>
  );
}

export default FilterCategoryPrice;